<template>
    <div>
        <Chat
            v-if="expoDataLoaded && roomType !== 'map' && roomStr"
            ref="chat"
            :expoId="expoId"
            :roomStr="roomStr"
            :roomType="roomType"
        />
        <Audience ref="inThisRoom" :expoId="expoId" :roomStr="roomStr" :userConv="expoId + '/' + roomStr + '?conv=' + currentConv" :newConv="expoId + '/' + roomStr + '?conv=' + newConvId" />
        <ExpoContent v-if="expoDataLoaded" :type="roomType" :expoId="expoId" :roomDashStr="roomStr.replace('/','-')" :roomData="roomData" />
        <div v-if="roomType !== 'map'" @click="$router.push('/expo/' + expoId + '/' + getRoomStr(roomLevel - 1))" class="fixed-icon top-left grow-link back-link">
            <span class="tooltip">Go Back</span>
            <MdArrowBackIcon/>
        </div>
        <div v-if="roomType !== 'map'" @click="$smoothScroll({ scrollTo: $refs.inThisRoom.$el })" class="fixed-icon bot-left grow-link">
            <span class="tooltip">This Room</span>
            <img :src="getSrc()">
        </div>
        <Broadcast :expoId="expoId" />
    </div>
</template>

<script>
import Vue from 'vue'
import MdArrowBackIcon from 'vue-ionicons/dist/md-arrow-back.vue'
import { nanoid } from 'nanoid'

import Chat from './Chat'
import Audience from './Audience'
import ExpoContent from './content/ExpoContent'
import Broadcast from './Broadcast'
import { auth, firestore, rtdb, RTDB_TIMESTAMP } from '../../../db'

const expos = firestore.collection('expos')
const users = rtdb.ref('users')
const presence = rtdb.ref('presence')

export default {
    name: 'ExpoRoom',
    props: ['expoId', 'roomId1', 'roomId2', 'roomId3'],
    components: {
        MdArrowBackIcon,
        Chat,
        Audience,
        ExpoContent,
        Broadcast,
    },
    data() {
        return {
            expoData: {},
            expoDataLoaded: false,
            userMap: {},
            presentUserMap: {},
            newConvId: nanoid(14),
        }
    },
    computed: {
        roomStr() {
            return this.getRoomStr(this.roomLevel)
        },
        presenceStr() {
            let presenceStr = this.expoId + '/' + this.roomStr
            if (this.currentConv) {
                presenceStr += '?conv=' + this.currentConv
            }
            return presenceStr
        },
        roomIds() {
            var roomIds = []
            if (this.roomId1) roomIds.push(this.roomId1)
            if (this.roomId2) roomIds.push(this.roomId2)
            if (this.roomId3) roomIds.push(this.roomId3)
            return roomIds
        },
        roomLevel() {
            return this.roomIds.length
        },
        thisRoomId() {
            if (this.roomLevel == 0) return this.expoId
            return this.roomIds[this.roomLevel - 1]
        },
        roomData1() {
            return this.expoData.rooms[this.roomId1] || { name: ''}
        },
        roomData2() {
            return this.roomData1.rooms[this.roomId2] || { name: ''}
        },
        roomData3() {
            return this.roomData2.rooms[this.roomId3] || { name: ''}
        },
        roomData() {
            if (!this.expoData.rooms) return this.expoData
            var roomData = this.expoData
            for (let id of this.roomIds) {
                roomData = roomData.rooms[id]
            }
            if (!roomData) return { name: '' }
            else return roomData
        },
        expoName() { return this.expoData.name },
        roomType() {
            if (this.roomData.type) {
                return this.roomData.type
            } else if (this.roomData.iframe) {
                return 'iframe' // TODO: This should be defined in each room's 'type' instead of programmatic
            } else {
                return ''
            }
        },
        currentConv() {
            return this.$route.query.conv
        },
    },
    watch: {
        expoId: {
            immediate: true,
            handler(expoId) {
                var expoRoute = {
                    name: this.expoName,
                    to: '/expo/' + this.expoId
                }
                this.$store.dispatch('updatePageName', [expoRoute])
                this.$bind('expoData', expos.doc(expoId))
            }
        },
        expoData: {
            immediate: true,
            handler() {
                this.expoDataLoaded = true
            }
        },
        roomStr: {
            immediate: true,
            handler() {
                this.updatePresenceStr()
                var routes = [{
                    name: this.expoName,
                    to: '/expo/' + this.expoId
                }]
                if (this.expoData.rooms && this.roomId1) {
                    routes.push({
                        name: this.roomData1.name,
                        to: '/expo/' + this.expoId + '/' + this.roomId1
                    })
                }
                if (this.expoData.rooms && this.roomId2) {
                    routes.push({
                        name: this.roomData2.name,
                        to: '/expo/' + this.expoId + '/' + this.roomId1 + '/' + this.roomId2
                    })
                }
                if (this.expoData.rooms && this.roomId3) {
                    routes.push({
                        name: this.roomData3.name,
                        to: '/expo/' + this.expoId + '/' + this.roomId1 + '/' + this.roomId2 + '/' + this.roomId3
                    })
                }
                this.$store.dispatch('updatePageName', routes)
            }
        },
        currentConv: {
            immediate: true,
            handler() {
                this.updatePresence()
                this.enterConvIfNone()
            }
        },
        presentUserMap: {
            immediate: true,
            handler(presentUserMap) {
                this.updateUserMap(Object.keys(presentUserMap))
            }
        }
    },
    methods: {
        getRoomStr(level) {
            if (level == 0) {
                return 'map'
            }
            var str = ''
            for (let id of this.roomIds.slice(0, level)) {
                str += id + '/'
            }
            return str.slice(0, str.length - 1)
        },
        getSrc() {
            if (this.roomData) {
                return this.roomData.img
            } else {
                return ''
            }
        },
        updateOneUser(uid) {
            Vue.set(this.userMap, uid, null)
            users.child(uid).once('value').then(snapshot => {
                Vue.set(this.userMap, uid, snapshot.val())
            })
        },
        async updateUserMap(uidList) {
            for (var i=0, n=uidList.length; i < n; i++) {
                var uid = uidList[i]
                if (!this.userMap[uid] || this.userMap[uid].currentRoom !== this.presentUserMap[uid].currentRoom) {
                    this.updateOneUser(uid)
                }
            }
        },
        getUser(uid) {
            if (uid && this.userMap[uid]) {
                return this.userMap[uid]
            } else {
                if (uid && this.userMap[uid] === null) {
                    this.updateOneUser(uid)
                }
                return {
                    first: '',
                    last: '',
                    org: '',
                    title: '',
                    email: '',
                    img: 'https://firebasestorage.googleapis.com/v0/b/one-expo.appspot.com/o/users%2Fuser.svg?alt=media&token=e4d595b3-3c3b-464e-88cb-d9238b8525d2',
                    uid: uid,
                    profiles: {}
                }
            }
        },
        enterConvIfNone() {
            if (!this.currentConv) {
                this.$router.push('/expo/' + this.expoId + '/' + this.roomStr + '?conv=' + this.newConvId)
            }
        },
        generateNewConv() {
            this.newConvId = nanoid(14)
        },
        updatePresence() {
            if (this.roomStr) {
                this.updatePresenceStr()
            }
        },
        async updatePresenceStr() {
            if (auth.currentUser) {
                presence.child(auth.currentUser.uid).set({
                    currentRoom: this.presenceStr,
                    dt: RTDB_TIMESTAMP
                })
                users.child(auth.currentUser.uid).update({
                    currentRoom: this.presenceStr,
                })
            } else {
                setTimeout(this.updatePresence, 100)
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.updatePresence()
        })
    },
    mounted() {
        this.updatePresence()
        this.$rtdbBind('presentUserMap', presence.orderByChild('currentRoom').startAt(this.expoId + '/' + this.roomStr).endAt(this.expoId + '/' + this.roomStr + '\uf8ff'))
    },
    created() {
        this.timer = setInterval(this.updatePresence,    300000)
        this.enterConvIfNone()
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    destroyed() {
        clearInterval(this.timer)
    },
}
</script>

<style lang="scss" scoped>
@import '/src/expo.scss';
</style>